import { createContext, useContext, useEffect, useState } from "react";
import { fetchSiteSettings } from "@/lib/api";

const SettingsContext = createContext({ settings: null, loading: true, refresh: () => {} });

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = async () => {
        setLoading(true);
        try {
            const data = await fetchSiteSettings();
            setSettings(data);
        } catch (e) {
            // graceful fallback: keep defaults
            setSettings({
                business_name: "Smokin' Mo's Southern BBQ",
                tagline: "All Meats Wood Smoked On Site Every Day",
                address: "15 Route 206 S, Sandyston, NJ 07826",
                phone: "862-303-2001",
                email: "moaugust1967@yahoo.com",
                hours: "Thursday – Sunday  ·  11am – 7pm",
                instagram_url: "https://www.instagram.com/smokinmossouthernbbq",
                facebook_url: "https://www.facebook.com/profile.php?id=61557402064901",
                tiktok_url: "",
                youtube_url: "",
                google_calendar_embed_url: "",
                ga4_measurement_id: "",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        refresh();
    }, []);

    return (
        <SettingsContext.Provider value={{ settings, loading, refresh }}>
            {children}
        </SettingsContext.Provider>
    );
}

export function useSettings() {
    return useContext(SettingsContext);
}
